var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMsgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1753 52.4997H48.8253C52.6753 52.4997 55.0753 48.3247 53.1503 44.9997L34.3253 12.4747C32.4003 9.14971 27.6003 9.14971 25.6753 12.4747L6.8503 44.9997C4.9253 48.3247 7.3253 52.4997 11.1753 52.4997ZM30.0003 34.9997C28.6253 34.9997 27.5003 33.8747 27.5003 32.4997V27.4997C27.5003 26.1247 28.6253 24.9997 30.0003 24.9997C31.3753 24.9997 32.5003 26.1247 32.5003 27.4997V32.4997C32.5003 33.8747 31.3753 34.9997 30.0003 34.9997ZM32.5003 42.4997C32.5003 43.8804 31.381 44.9997 30.0003 44.9997C28.6196 44.9997 27.5003 43.8804 27.5003 42.4997C27.5003 41.119 28.6196 39.9997 30.0003 39.9997C31.381 39.9997 32.5003 41.119 32.5003 42.4997Z",
    fill: "#E85A44"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgWarning);
export default __webpack_public_path__ + "static/media/msg-warning.24f19799.svg";
export { ForwardRef as ReactComponent };